// Модуль на JS, типы — в startupScreenMarkup.d.ts. Его подключает и vite.config приложения (проект
// tsconfig.node.json), а TS-файл, общий с проектом приложения, tsc не пропускает: проект конфига стоит в references
// (TS6305, если файл в его include, и TS6307, если нет). Импортов нет: конфиг Vite собирает модуль сам.

const escapeAttribute = (value) => value.replace(/&/g, '&amp;').replace(/"/g, '&quot;');

const logo = (src, className) =>
    `<img class="${className}" src="${escapeAttribute(src)}" alt="Bidzaar SRM" height="20" />`;

export const buildStartupScreenMarkup = ({ logoSrc, logoColorSrc, logoBadgeHtml }) => {
    const header = [
        logo(logoSrc, 'app-startup__logo'),
        logoColorSrc ? logo(logoColorSrc, 'app-startup__logo app-startup__logo--color') : '',
        logoBadgeHtml ?? '',
    ]
        .filter(Boolean)
        .join('\n    ');

    return `<header class="app-startup__header">
    ${header}
</header>
<main class="app-startup__workspace" aria-busy="true">
    <div class="app-startup__feedback">
        <div class="app-startup__emblem" aria-hidden="true">
            <span class="app-startup__layer app-startup__layer--back"></span>
            <span class="app-startup__layer app-startup__layer--middle"></span>
            <span class="app-startup__layer app-startup__layer--front"></span>
        </div>
        <p class="app-startup__status" role="status" aria-label="Загрузка">Загрузка</p>
    </div>
</main>
`;
};

const PLACEHOLDER = '<!--app-startup-->';

export const startupScreenHtmlPlugin = (options) => ({
    name: 'startup-screen-html',
    transformIndexHtml: {
        order: 'pre',
        // Функцией: строка замены разобрала бы `$&` и подобное в путях.
        handler: (html) => html.replace(PLACEHOLDER, () => buildStartupScreenMarkup(options)),
    },
});
